import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, IconButton, styled, Typography } from '@mui/material';

export const StyledHeader = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: ` 0 0 ${tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xs} 0`,
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
    position: 'sticky',
    top: '0',
    backgroundColor: tsoPqTheme.palette.background.other.color_other_background_white,
    zIndex: '99',
  };
});

export const StyledConfirmationHeader = styled(Box)(() => {
  return {
    padding: 0,
  };
});

export const StyledTitleWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
  };
});

export const StyledTitle = styled(Typography)(() => {
  return {
    color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_title_section_smaller,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '2.125rem',
    paddingTop: '0.25rem',
  };
});

export const StyledInputsWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$fieldWidth',
})(({ fieldWidth }: { fieldWidth?: string }) => {
  const gap = tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24;
  return {
    display: 'grid',
    gridTemplateColumns: `${fieldWidth} ${fieldWidth}`,
    gap,
    maxWidth: `calc(2 * ${fieldWidth} + ${gap})`,
  };
});

export const StyledInputFieldWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$fullWidth',
})<{ $fullWidth?: boolean }>(({ $fullWidth }) => ({
  gridColumn: $fullWidth ? 'span 2' : 'auto',
}));

export const StyledDeleteButton = styled(IconButton)(() => {
  return {
    height: '2.125rem',
    width: '2.125rem',
    display: 'flex',
    justifyContent: 'center',

    '&:focus': { outline: 'none' },
    '&.Mui-disabled': {
      opacity: 0.65,
      pointerEvents: 'none',
    },
  };
});
